
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import BaseButton from "../widgets/BaseButton.vue";
import BaseCheckbox from "../core/BaseCheckbox.vue";

@Component({
  name: "TermsAndConditionsForm",
  components: {
    BaseButton,
    BaseCheckbox,
  },
})
export default class TermsAndConditionsForm extends Vue {
  @Prop({ default: null }) readonly tcLink!: string;

  @Prop({ default: null }) readonly ppLink!: string;

  agreedToTC = false;

  invalidForm = false;

  onCheckOrUncheck(value: boolean) {
    this.agreedToTC = value;
    this.invalidForm = !this.agreedToTC;
  }

  async submitAgreement() {
    this.invalidForm = !this.agreedToTC;
    if (this.invalidForm) {
      return;
    }
    this.$emit("onSubmit");
  }
}
